import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { darken } from '@mui/material/styles';

import useParam from '../../../context/ParamContext';
import JMWithAccountingJobmonitorCard from './JMWithAccountingJobmonitorCard';
import masterDataService from '../../../service/masterData.service';
import { generateAutocompleteItems, getContrastColor } from '../../../utils/helper';
import { AttachmentDialogUI, AutoCompleteSelectUI, DebouncedInputUI, FormLabelUI, SwitchUI } from '../../Interface';
import userService from '../../../service/user.service';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import OperationWidgetDialog from '../../OperationWidget/OperationWidgetDialog';
import JMWithAccountingGrouppedOperationDialog from './JMWithAccountingGrouppedOperationDialog';
import productionService from '../../../service/production.service';
import { Tooltip, Typography } from '@mui/material';
import TaskFeedbackDialog from '../../TaskFeedback/TaskFeedbackDialog';
import sourcelistService from '../../../service/sourcelist.service';
import { useLoader } from '../../../provider/LoaderProvider';
import jmWithAccountingJobMonitorService from '../../../service/jmWithAccountingJobMonitor.service';

export const JMWithAccountingJobmonitorPage = () => {
  const { showLoader, hideLoader } = useLoader();
  const timeoutRef = useRef(null);
  const { getParam, params } = useParam();
  const [prodOperations, setProdOperations] = useState({ rows: [], rowCount: 0 });
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    groupReporting: [],
    operations: [],
    status: [],
    scrap: [],
    resourceOne: [],
  });
  const [reasons, setReasons] = useState({
    interruption: [],
    downtime: [],
  });
  const [helperData, setHelperData] = useState({});
  const [useGroupped, setUseGroupped] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [checkedIds, setCheckedIds] = useState([]);
  const [checkedOperations, setCheckedOperations] = useState([]);
  const [grouppedOpDialog, setGrouppedOpDialog] = useState(false);
  const [filter, setFilter] = useState({
    userId: null,
    operationId: null,
    resourceOneId: null,
    pinCode: '',
    label: [],
    prevStatus: false,
  });
  const [query, setQuery] = useState({
    filter: {
      filterModel: {
        items: [],
        logicOperator: 'and',
      },
    },
    sorting: {
      sortModel: [],
    },
    pagination: {
      paginationModel: {},
    },
  });
  const [showDialog, setShowDialog] = useState(false);
  const [feedBackDialogData, setFeedbackDialogData] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [isAttachmentDialogOpen, setIsAttachmentDialogOpen] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    if (!filter.resourceOneId) {
      setShowDialog(true);
    }
  }, [filter.resourceOneId]);

  useEffect(() => {
    getParam();
    initDefaultValues();
  }, []);

  useEffect(() => {
    if (!useGroupped) {
      setCheckedIds([]);
      setCheckedOperations([]);
    }
  }, [useGroupped]);

  useEffect(() => {
    if (filter.pinCode) {
      getUserByPinCode();
    }
  }, [filter.pinCode]);

  useEffect(() => {
    if (Object.keys(params).length > 0 && filter.resourceOneId) {
      const statusConfig = JSON.parse(params.JOBMONITOR_STATUSES);
      const statusIds = statusConfig.noPreviousWork;
      handleFilterChange(
        [
          { field: 'resourceOneId', operator: 'is', value: filter.resourceOneId },
          { field: 'prodOpStatusId', operator: 'isAnyOf', value: statusIds },
          ...(filter?.reference ? [{ field: 'reference', operator: 'contains', value: filter.reference }] : []),
          ...(filter?.label?.length > 0 ? [{ field: 'label', operator: 'isAnyOf', value: filter.label }] : []),
          ...(filter?.AlapanyagItemCode
            ? (() => {
                const parts = filter.AlapanyagItemCode.split(' - ');
                if (parts.length === 2) {
                  return [
                    { field: 'AlapanyagItemCode', operator: 'contains', value: parts[0] },
                    { field: 'AlapanyagItemName', operator: 'contains', value: parts[1] },
                  ];
                } else {
                  return [
                    {
                      field: 'AlapanyagItemCode',
                      operator: 'contains',
                      value: filter.AlapanyagItemCode,
                    },
                  ];
                }
              })()
            : []),
          ...(filter?.operationId ? [{ field: 'operationId', operator: 'contains', value: filter.operationId }] : []),
          ...(filter?.prevStatus
            ? [{ field: 'prevStatus', operator: 'isAnyOf', value: ['COMPLETED', 'VERIFIED'] }]
            : []),
        ],
        null,
        null,
        true
      );
    }
  }, [
    params,
    filter.resourceOneId,
    filter.reference,
    filter.label,
    filter.AlapanyagItemCode,
    filter.operationId,
    filter.prevStatus,
  ]);

  useEffect(() => {
    if (query.filter.filterModel.items.length > 0) {
      getList();
    }
  }, [query]);

  useEffect(() => {
    if (refetch && query.filter.filterModel.items.length > 0) {
      getList();
      setRefetch(false);
    }
  }, [refetch]);

  useEffect(() => {
    if (filter.operationId && filter.resourceOneId) {
      getGroupReportingOptions();
    }
  }, [filter.operationId, filter.resourceOneId]);

  useEffect(() => {
    if (params.USE_COMPANY_BREAK === 'Y' && filter.resourceOneId) {
      const intervalId = setInterval(() => {
        getBreakByUserId();
      }, 60000);

      return () => clearInterval(intervalId);
    }
  }, [filter.resourceOneId]);

  useEffect(() => {
    if (
      (!filter.resourceOneId && !params.VM_OPERATION_WIDGET_ACTIVITY) ||
      !Number(params.VM_OPERATION_WIDGET_ACTIVITY)
    ) {
      return;
    }

    const handleActivity = () => resetTimer();

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('scroll', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    resetTimer();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
      clearTimeout(timeoutRef.current);
    };
  }, [filter.resourceOneId, params]);

  useEffect(() => {
    getResourceOneGroupsByUserId();
  }, [filter.userId]);

  const getResourceOneGroupsByUserId = () => {
    if (!filter.userId) return;

    masterDataService.resourceOneGroupsByUserIdToForm(filter.userId).then((data) => {
      setMachines(data);
    });
  };

  const getUserByPinCode = () => {
    setProdOperations({ rows: [], rowCount: 0 });
    userService.getUserByPinCode(filter.pinCode).then((data) => {
      if (Object.keys(data).length > 0) {
        setFilter((prev) => ({
          ...prev,
          resourceOneId: data.resourceOneId,
          nickName: data.nickName,
          userId: data.userId,
        }));
        setShowDialog(false);
      } else {
        addNotification({
          content: 'Nem található felhasználó ezzel a PIN kóddal!',
          type: NotificationType.ERROR,
        });
      }
    });
  };

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .operationToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .productionStatusToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .interruptionReasonsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .downTimeReasonsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .operationGroupToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .scrapReasonsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceOneToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .itemsFromTableToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );
    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .warehouseToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          operations: resp[0],
          status: resp[1],
          interruption: resp[2],
          downtime: resp[3],
          operationGroup: resp[4],
          scrap: resp[5],
          resourceOne: resp[6],
          items: resp[7],
          warehouse: resp[8],
        };
        setReasons({ downtime: aData.downtime, interruption: aData.interruption });
        setHelperData(aData);

        const acOptions = {
          operations: generateAutocompleteItems(aData.operations, 'operationName', 'operationId'),
          status: generateAutocompleteItems(aData.status, 'name', 'code'),
          scrap: generateAutocompleteItems(aData.scrap, 'name', 'id'),
          resourceOne: generateAutocompleteItems(aData.resourceOne, 'name', 'id'),
        };

        setAutoCompleteOptions((prev) => ({
          ...prev,
          ...acOptions,
        }));
      })
      .finally(() => {
        // hideLoader();
      });
  };

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setFilter((prev) => ({
        ...prev,
        resourceOneId: null,
        pinCode: '',
      }));

      resetTimer();
    }, params.VM_OPERATION_WIDGET_ACTIVITY);
  };

  const getGroupReportingOptions = () => {
    masterDataService.groupReportingToForm(filter.operationId, filter.resourceOneId).then((data) => {
      if (data.length > 0) {
        const transformed = generateAutocompleteItems(data, ['reference', 'finishedItemCode', 'name'], 'id');

        setAutoCompleteOptions((prev) => ({
          ...prev,
          groupReporting: transformed,
        }));
      }
    });
  };

  const getList = () => {
    showLoader();
    jmWithAccountingJobMonitorService
      .getProductionOperationsFromView(query)
      .then((data) => {
        setProdOperations(data);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleFilterChange = (fieldOrFilters, operator = null, value = null, clearExisting = false) => {
    setQuery((prev) => {
      const filtersToAdd = Array.isArray(fieldOrFilters)
        ? fieldOrFilters
        : [{ field: fieldOrFilters, operator, value }];

      const validFilters = filtersToAdd
        .filter((f) => f.value !== null && f.value !== undefined)
        .map((f) => ({
          field: f.field,
          operator: f.operator ?? operator,
          value: f.value?.value ?? f.value,
        }));

      return {
        ...prev,
        filter: {
          filterModel: {
            items: clearExisting
              ? validFilters
              : [
                  ...prev.filter.filterModel.items.filter((item) => !filtersToAdd.some((f) => f.field === item.field)),
                  ...validFilters,
                ],
          },
        },
      };
    });
  };

  const handleCheckboxChange = (isChecked, id = null) => {
    if (useGroupped) {
      if (isChecked) {
        setCheckedIds((prev) => {
          const checkCopy = [...prev];
          checkCopy.push(id);
          return checkCopy;
        });

        const findedOp = prodOperations.rows.find((op) => op.productionoperationid === id);
        setCheckedOperations((prev) => {
          const checkCopy = [...prev];
          checkCopy.push(findedOp);
          return checkCopy;
        });
      } else {
        const isCheckedId = checkedIds.includes(id);
        if (isCheckedId) {
          setCheckedIds((prev) => prev.filter((item) => item !== id));
          setCheckedOperations((prev) => prev.filter((item) => item.productionoperationid !== id));
        }
      }
      return;
    }
  };

  const saveGrouppedOperations = async (selectedEmployees = []) => {
    const values = {
      userId: filter.userId,
      createdBy: filter.userId,
      id: checkedIds,
      employees: selectedEmployees,
    };
    setDisableBtn(true);
    try {
      await productionService.createProductionReport(values);
      setRefetch(true);
      setGrouppedOpDialog(false);
      setCheckedIds([]);
      setCheckedOperations([]);
      setUseGroupped(false);
    } finally {
      setDisableBtn(false);
    }
  };

  const getBreakByUserId = () => {
    productionService.getBreakByUserId(filter.resourceOneId).then((breakData) => {
      setProdOperations((prev) => {
        const updatedRows = prev.rows.map((row) => {
          const updated = breakData.find((item) => item.id === row.id);
          if (updated) {
            return {
              ...row,
              productionReport: updated.productionReport,
            };
          }
          return row;
        });

        return {
          ...prev,
          rows: updatedRows,
        };
      });
    });
  };

  const getSourceListAttachment = (itemCode) => {
    setIsAttachmentDialogOpen(true);
    sourcelistService.getSourcelistAttachmentByItemCode(itemCode).then((data) => {
      setAttachments([...data.sourceListAttachment, ...data.itemAttachment]);
    });
  };

  const handleResourceOneSelect = (resourceOneId) => {
    setProdOperations({ rows: [], rowCount: 0 });
    setFilter((prev) => ({
      ...prev,
      resourceOneId: resourceOneId ?? null,
    }));
    setShowDialog(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#E9F5FE',
        height: 'calc(100vh - 48px)',
      }}
    >
      {machines.length > 0 && (
        <Box
          sx={{
            px: 2,
            pt: 2,
            pb: 1,
            mb: 1,
            overflowX: 'auto',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              width: 'fit-content',
              mx: 'auto',
              alignItems: 'stretch',
              py: 1,
            }}
          >
            {machines.map((group) =>
              group.resourceOne.map((machine) => {
                const isSelected = String(machine.id) === String(filter.resourceOneId);
                const machineName = machine.name ?? '';
                const shortName = machineName.substring(0, 6);

                return (
                  <Tooltip key={machine.id} title={machineName} arrow>
                    <Box
                      role="button"
                      tabIndex={0}
                      onClick={() => handleResourceOneSelect(machine.id)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleResourceOneSelect(machine.id);
                        }
                      }}
                      sx={{
                        minWidth: 90,
                        px: 1.5,
                        py: 1,
                        borderRadius: 1,
                        borderStyle: 'solid',
                        borderWidth: isSelected ? 3 : 1,
                        borderColor: isSelected ? '#222425' : darken(group.color, 0.3),
                        bgcolor: group.color,
                        color: getContrastColor(group.color),
                        cursor: 'pointer',
                        userSelect: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      <Typography sx={{ fontWeight: 700 }} variant="body2">
                        {shortName}
                      </Typography>
                    </Box>
                  </Tooltip>
                );
              })
            )}
          </Box>
        </Box>
      )}

      <Grid
        container
        spacing={2}
        sx={{
          px: 2,
          mb: 2,
        }}
      >
        <Grid item xs={1}>
          <Box pt="0.8rem">
            <SwitchUI
              checked={useGroupped}
              onChange={(e) => setUseGroupped(e.target.checked)}
              label={<FormLabelUI text="Csoportosítás" />}
            />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <DebouncedInputUI
            label="Gyártási utasítás"
            debounceMs={800}
            limitTags={3}
            quickFilterSearchValue={filter?.label}
            mode="multi"
            setQuickFilterSearchValue={(newValue) => {
              setFilter((prevState) => ({
                ...prevState,
                label: newValue ?? undefined,
              }));
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <DebouncedInputUI
            label="Hivatkozási szám"
            debounceMs={800}
            quickFilterSearchValue={filter?.reference}
            setQuickFilterSearchValue={(newValue) => {
              setFilter((prevState) => ({
                ...prevState,
                reference: newValue ?? undefined,
              }));
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <DebouncedInputUI
            label="Alapanyag szűrés"
            debounceMs={800}
            quickFilterSearchValue={filter?.AlapanyagItemCode}
            setQuickFilterSearchValue={(newValue) => {
              setFilter((prevState) => ({
                ...prevState,
                AlapanyagItemCode: newValue ?? undefined,
              }));
            }}
          />
        </Grid>
        <Grid item xs={1.5}>
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Művelet kereső" />}
            dataset={autoCompleteOptions.operations.filter((operation) =>
              prodOperations?.rows?.some((row) => row.operationId === operation.value)
            )}
            onChange={(_e, newVal) => {
              setFilter((prevState) => ({
                ...prevState,
                operationId: newVal?.value ?? undefined,
              }));
            }}
            selectedValue={filter.operationId}
          />
        </Grid>
        <Grid item xs={1.2}>
          <Box pt="0.8rem">
            <SwitchUI
              checked={filter.prevStatus}
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  prevStatus: e.target.checked,
                }))
              }
              label={<FormLabelUI text="Előző műv. bef." />}
            />
          </Box>
        </Grid>
        {filter?.nickName && (
          <Grid item xs={2.3}>
            <Box pt="1rem" display="flex" gap="0.5rem" alignItems="center" justifyContent="end">
              <AccountCircleIcon sx={{ fontSize: '28px', color: '#4481D3' }} />
              <Typography sx={{ fontWeight: 'bold', color: '#4481D3', fontSize: '20px' }}>
                {filter?.nickName}
              </Typography>
              <Typography
                ml="1rem"
                sx={{ cursor: 'pointer', fontWeight: 'bold', color: '#4481D3', fontSize: '20px' }}
                onClick={() =>
                  setFilter((prev) => ({
                    ...prev,
                    resourceOneId: null,
                    pinCode: '',
                  }))
                }
              >
                Kilépés
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
      <Box sx={{ px: 2 }}>
        <Grid
          container
          spacing={1}
          direction="row"
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {prodOperations.rows.length > 0 &&
            prodOperations.rows.map((operation) => (
              <JMWithAccountingJobmonitorCard
                key={operation.productionoperationid}
                data={operation}
                setRefetch={setRefetch}
                userId={filter.userId}
                checkedIds={checkedIds}
                handleCheckboxChange={handleCheckboxChange}
                rows={prodOperations.rows}
                params={params}
                helperData={helperData}
                reasons={reasons}
                useGrouppedState={{ useGroupped, setUseGroupped }}
                setGrouppedOpDialog={setGrouppedOpDialog}
                autoCompleteOptions={autoCompleteOptions}
                feedBackDialogDataState={{ feedBackDialogData, setFeedbackDialogData }}
                getSourceListAttachment={getSourceListAttachment}
              />
            ))}
        </Grid>
      </Box>

      <OperationWidgetDialog
        open={showDialog}
        handleClose={() => setShowDialog(false)}
        filterState={{ filter, setFilter }}
      />

      <JMWithAccountingGrouppedOperationDialog
        show={grouppedOpDialog && useGroupped}
        onClose={() => {
          setGrouppedOpDialog(false);
        }}
        onSave={saveGrouppedOperations}
        fullWidth={true}
        maxWidth="lg"
        checkedOperations={checkedOperations}
        helperData={helperData}
        disableBtn={disableBtn}
      />
      {feedBackDialogData && (
        <TaskFeedbackDialog
          open={feedBackDialogData}
          handleClose={() => setFeedbackDialogData(null)}
          data={feedBackDialogData}
        />
      )}

      <AttachmentDialogUI
        open={isAttachmentDialogOpen}
        data={attachments}
        handleClose={() => setIsAttachmentDialogOpen(false)}
      />
    </Box>
  );
};
